module.exports = "<div class=\"linePreloader\"></div>"